import React from 'react';
import PropTypes from 'prop-types';

import {
  END_DATE,
} from '@zr/utilities/profileFields';

import { STRING_FIELD_END_YEAR } from '../labels';

import FormikLabeledField from './FormikLabeledField';
import YearOptions from '../YearOptions';

import formikPropTypes from './formikPropTypes';

export function EndYearField({
  disabled, name, placeholder, formikProps,
}) {
  const { errors } = formikProps;

  return (
    <FormikLabeledField
      as="select"
      disabled={disabled}
      // since the profile field is the date combined, also display errors with that field
      error={errors[name] || errors[END_DATE]}
      formikProps={formikProps}
      name={name}
      label={STRING_FIELD_END_YEAR}
      placeholder={placeholder || STRING_FIELD_END_YEAR}
    >
      <YearOptions />
    </FormikLabeledField>
  );
}

EndYearField.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
  placeholder: PropTypes.string,
};

EndYearField.defaultProps = {
  disabled: false,
  placeholder: null,
};

export default EndYearField;
